import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { observer } from 'mobx-react';
import { BaasicButton, BaasicDragAndDrop, BaasicDragAndDropItem, Loader } from 'core/components';
import { isSome } from 'core/utils';
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';

const SplitFulfillmentOrderTemplate = ({
	t,
	splitFulfillmentOrderViewStore: {
		loading,
		dragAndDropField,
		fulfillmentOrder,
		initialFulfillmentOrderDropBox,
		dropBoxList,
		addNewFulfillmentOrder,
		onDropCallback,
		onCanDropCallback,
		onCanDragCallback,
		closeModal,
		validateFulfillmentOrders,
		onFulfillmentOrderDelete,
		isEdit,
		originalFulfillmentOrderId,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<div className="ReactModal__header">
				<div className="flex--secondary">
					<h3 className="spc--bottom--sml">
						{t(isEdit ? 'SPLITFULFILLMENTORDERMODAL.EDITTITLE' : 'SPLITFULFILLMENTORDERMODAL.TITLE')}
					</h3>
				</div>
			</div>
			<div className="ReactModal__body">
				<div className="split">
					<div className="split__main">
						<div className="split__box">
							<div className="split__box__header">
								<div className="split__box__header__title">
									#{fulfillmentOrder.fulfillmentOrderId}
									{isEdit && fulfillmentOrder.id == originalFulfillmentOrderId && (
										<div className="split__box__header__status">{t('SPLITFULFILLMENTORDERMODAL.ORIGINALFO')}</div>
									)}
								</div>
								<div className="split__box__header__status">
									{t(isEdit ? 'SPLITFULFILLMENTORDERMODAL.FOINEDIT' : 'SPLITFULFILLMENTORDERMODAL.ORIGINALFO')}
								</div>
							</div>
							<div className="split__box__table__header">
								<div className="flex--grow--1">{t('SPLITFULFILLMENTORDERMODAL.SKU')}</div>
								<div className="w--30--px type--center">{t('SPLITFULFILLMENTORDERMODAL.QUANTITY')}</div>
							</div>
							<BaasicDragAndDrop
								{...{ dragAndDropField, onCanDropCallback, onDropCallback }}
								dropBox={initialFulfillmentOrderDropBox}
								key={initialFulfillmentOrderDropBox.key}
							>
								{_.map(initialFulfillmentOrderDropBox.items, item => {
									return (
										<BaasicDragAndDropItem
											{...{ item, onCanDragCallback, dragAndDropField }}
											currentDropBox={initialFulfillmentOrderDropBox}
											ItemComponent={FulfillmentOrderItemDnDComponent}
											key={item.key}
										/>
									);
								})}
								<p className="split__drop">{t('SPLITFULFILLMENTORDERMODAL.PLACEHOLDER.SKU')}</p>
							</BaasicDragAndDrop>
							<div className="type--center split__btn--more">
								<BaasicButton
									className="btn btn--med btn--ghost"
									onClick={addNewFulfillmentOrder}
									type="button"
									label="SPLITFULFILLMENTORDERMODAL.SPLITMORE"
									icon="fa fa-plus spc--right--sml"
								/>
							</div>
						</div>
					</div>
					<div className="split__icon__wrap">
						<div className="split__icon"></div>
					</div>
					<div className="split__aside__wrap">
						<div className="split__aside">
							<div className="message message--primary message--primary--info">
								{t(
									isEdit
										? 'SPLITFULFILLMENTORDERMODAL.PLACEHOLDER.EDITTIP'
										: 'SPLITFULFILLMENTORDERMODAL.PLACEHOLDER.TIP'
								)}
							</div>

							<div className="split__aside__list">
								{_.map(dropBoxList, (dropBox, index) => {
									return (
										<div
											className={
												'split__box__holder ' +
												(dropBox.onePerBox || dropBox.hasLabel
													? 'has-one'
													: dropBox.items.length == 0 && dropBox.id != ''
													? 'is-empty'
													: null)
											}
										>
											<div className="split__box" key={dropBox.key}>
												<div className="split__box__header">
													<div className="split__box__header__title">
														#
														{isSome(dropBox.fulfillmentOrderId) && dropBox.fulfillmentOrderId != ''
															? dropBox.fulfillmentOrderId
															: 'FO' + (index + 1)}
														{(dropBox.onePerBox ||
															dropBox.hasLabel ||
															(dropBox.items.length == 0 && dropBox.id != '')) && (
															<span>
																<i
																	data-tip={t(
																		dropBox.onePerBox
																			? 'SPLITFULFILLMENTORDERMODAL.ONEPERBOX'
																			: dropBox.hasLabel
																			? 'SPLITFULFILLMENTORDERMODAL.HASLABEL'
																			: 'SPLITFULFILLMENTORDERMODAL.DELETEFO'
																	)}
																	className="spc--left--tny fas fa-exclamation-circle"
																/>
																<ReactTooltip />
															</span>
														)}
														{isEdit && dropBox.id == originalFulfillmentOrderId && (
															<div className="split__box__header__status">
																{t('SPLITFULFILLMENTORDERMODAL.ORIGINALFO')}
															</div>
														)}
													</div>
													{((isEdit && !dropBox.onePerBox && !dropBox.hasLabel) || (!isEdit && index != 0)) && (
														<BaasicButton
															className="btn btn--icon btn--ghost"
															onClick={() => onFulfillmentOrderDelete(dropBox, index)}
															type="button"
															icon="fa fa-times"
														/>
													)}
												</div>

												<div className="split__box__table__header">
													<div className="flex--grow--1">{t('SPLITFULFILLMENTORDERMODAL.SKU')}</div>
													<div className="w--30--px type--center">{t('SPLITFULFILLMENTORDERMODAL.QUANTITY')}</div>
												</div>
												<BaasicDragAndDrop
													{...{ dropBox, onCanDropCallback, onDropCallback, dragAndDropField }}
													key={dropBox.key}
												>
													{_.map(dropBox.items, item => {
														return (
															<BaasicDragAndDropItem
																{...{ item, onCanDragCallback, dragAndDropField }}
																currentDropBox={dropBox}
																ItemComponent={FulfillmentOrderItemDnDComponent}
																key={item.key}
															/>
														);
													})}
													<p className="split__drop">{t('SPLITFULFILLMENTORDERMODAL.PLACEHOLDER.SKU')}</p>
												</BaasicDragAndDrop>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="ReactModal__footer">
				<BaasicButton
					className="btn btn--med btn--primary spc--bottom--sml"
					onClick={validateFulfillmentOrders}
					label="SAVE"
				/>
				<BaasicButton className="btn btn--med btn--ghost spc--bottom--sml" onClick={closeModal} label="CANCEL" />
			</div>
		</React.Fragment>
	);
};

const FulfillmentOrderItemDnDComponent = observer(({ drag, isDragging, item }) => {
	return (
		<div className="split__box__table__row" key={item.key}>
			<div
				ref={drag}
				className="input"
				style={{
					border: isDragging ? '1px solid #27788A' : '1px solid #DEDEDE',
					outline: isDragging ? '2px solid #c7e8ef' : '',
				}}
			>
				<i className="fa fa-grip-vertical"></i>
				{item.sku}
			</div>
			<div className="qty">{item.quantity}</div>
		</div>
	);
});

export default defaultTemplate(SplitFulfillmentOrderTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/SplitFulfillmentOrderTemplate.jsx